const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const API_BASE = isLocal
  ? "https://bullion-backend-5pu3.onrender.com"
  : "https://bullion-backend-5pu3.onrender.com";

export default API_BASE;
